// extracted by mini-css-extract-plugin
export var pageContainer = "_s-1";
export var settingsContent = "_s-0";